import { render, staticRenderFns } from "./DashboardLMS.vue?vue&type=template&id=219b9e80&"
import script from "./DashboardLMS.vue?vue&type=script&lang=js&"
export * from "./DashboardLMS.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLMS.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports